import data from "../../../../../src/SubNav.docs.json";
import * as React from 'react';
export default {
  data,
  React
};